/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PID Simulations contestation request payload
 * @export
 * @interface PidSimulationContestationRequest
 */
export interface PidSimulationContestationRequest {
    /**
     * 
     * @type {string}
     * @memberof PidSimulationContestationRequest
     */
    simulationId?: string;
    /**
     * 
     * @type {number}
     * @memberof PidSimulationContestationRequest
     */
    invoiceId?: number;
}

/**
 * Check if a given object implements the PidSimulationContestationRequest interface.
 */
export function instanceOfPidSimulationContestationRequest(value: object): value is PidSimulationContestationRequest {
    return true;
}

export function PidSimulationContestationRequestFromJSON(json: any): PidSimulationContestationRequest {
    return PidSimulationContestationRequestFromJSONTyped(json, false);
}

export function PidSimulationContestationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PidSimulationContestationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationId': json['simulationId'] == null ? undefined : json['simulationId'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function PidSimulationContestationRequestToJSON(json: any): PidSimulationContestationRequest {
    return PidSimulationContestationRequestToJSONTyped(json, false);
}

export function PidSimulationContestationRequestToJSONTyped(value?: PidSimulationContestationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationId': value['simulationId'],
        'invoiceId': value['invoiceId'],
    };
}

